import { Component } from "preact";
import PropTypes from "prop-types";
import { combineClasses } from "@green24/npm-javascript-utils";
import libphonenumber from "google-libphonenumber";
import Fa from "./Fa";
import { ComponentUtils } from "@green24/npm-preact-utils";

const PNF = libphonenumber.PhoneNumberFormat;
const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance();

class PhoneNumber extends Component {
	render({className, style, number, validate, prefix, suffix, showValidationCheck}) {
		let regionCode, phoneNumber, valid;

		try {
			let numberInstance = phoneUtil.parseAndKeepRawInput(number, 'CZ');

			regionCode = phoneUtil.getRegionCodeForNumber(numberInstance);
			phoneNumber = phoneUtil.format(numberInstance, PNF.INTERNATIONAL);

			if(validate) {
				valid = phoneUtil.isValidNumber(numberInstance);
			}
		}
		catch (e) {
			phoneNumber = number;
			valid = false;
		}

		return (
			<span className={combineClasses("phone-number", className)} style={style}>
				{prefix}

				<span className={"region-code"}>{regionCode || '--'}</span>

				<span className={"number"}>{phoneNumber || ''}</span>

				{
					validate &&
					showValidationCheck &&
					<Fa icon={"check"} className={combineClasses("validation", valid && "valid")}/>
				}

				{
					ComponentUtils.resolvePolymorphProp(
						suffix,
						{
							function: f => f({
								rawNumber: number,
								formattedNumber: phoneNumber,
								validate,
								valid,
							}),
						},
						() => suffix,
					)
				}
			</span>
		);
	}

	static get propTypes() {
		return {
			className: PropTypes.string,
			style: PropTypes.object,
			children: PropTypes.any,

			number: PropTypes.string,
			validate: PropTypes.bool,
			showValidationCheck: PropTypes.bool,

			prefix: PropTypes.any,
			suffix: PropTypes.any,
		}
	}

	static get defaultProps() {
		return {
			validate: false,
			showValidationCheck: true,
		}
	}
}

export default PhoneNumber;
